import Layout from '@/layout'

const promoteRouter={
    path:'/promotecenter',
    component: Layout,
    redirect: '/index',
    alwaysShow: true,
    // name:'news',
    meta:{
      title:'推广中心',
      icon: 'message',
      roles: ['admin', 'editor']
    },
    children: [
      {
        path: 'customer',
        component: () => import('../../views/promotecenter/customer.vue'),
        name: 'customer',
        meta: {
          title: '采购客户',
          roles: ['admin'] // or you can only set roles in sub nav 或者只能在子导航中设置角色
        }
      },
      {
        path: 'merchants',
        component: () => import('../../views/promotecenter/merchants.vue'),
        name: 'merchants',
        meta: {
          title: '入驻商户',
          roles: ['admin'] // or you can only set roles in sub nav 或者只能在子导航中设置角色
        }
      },{
        path: 'recommendation',
        component: () => import('../../views/promotecenter/recommendation.vue'),
        name: 'recommendation',
        meta: {
          title: '推荐渠道',
          roles: ['admin'] // or you can only set roles in sub nav 或者只能在子导航中设置角色
        }
      }
      
    ]
   
}
export default promoteRouter